import { Zap, Megaphone, Clock, Target, Smartphone, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface BadgeStatusAptidaoProps {
  statusAptidao: string;
  tipoLead?: string;
  /** chip translúcido para o hero vinho do modal (texto branco, sem emoji) */
  sobreVinho?: boolean;
}

// Status uniforme (1 regra só):
//  - RENOVAÇÃO: APTO / MKT / NÃO APTO (regra da carteira)
//  - Todo o resto / sem dado de carteira: PROSPECT
const CONFIG: Record<string, { label: string; Icone: LucideIcon }> = {
  APTO: { label: 'Apto', Icone: Zap },
  APTO_COM_APARELHO: { label: 'Apto com aparelho', Icone: Smartphone },
  MKT: { label: 'MKT', Icone: Megaphone },
  'NÃO APTO': { label: 'Não apto', Icone: Clock },
  PROSPECT: { label: 'Prospect', Icone: Target },
};

export function BadgeStatusAptidao({ statusAptidao, sobreVinho }: BadgeStatusAptidaoProps) {
  const cfg = CONFIG[statusAptidao] || { label: statusAptidao, Icone: Target };
  const { Icone } = cfg;
  if (sobreVinho) {
    return (
      <span className="inline-flex h-[30px] items-center gap-1.5 rounded-full border border-white/[0.16] bg-white/[0.10] px-3 text-[12px] font-semibold text-white">
        <Icone className="h-3.5 w-3.5 text-white/85" />
        {cfg.label}
      </span>
    );
  }
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold',
        statusAptidao === 'APTO'
          ? 'border-[#075E54]/40 bg-[#075E54]/[0.06] text-[#075E54] dark:text-[#25D366]'
          : statusAptidao === 'NÃO APTO'
            ? 'border-primary/40 bg-primary/5 text-primary dark:text-[#C87484]'
            : 'border-border bg-muted/40 text-foreground',
      )}
    >
      <Icone className="h-3 w-3" />
      {cfg.label}
    </span>
  );
}
